import { API_ENDPOINTS } from "../../../Api/apiEndPoints";
import axiosInstance from "../../../Api/axiosInstance";

export const getLanguageList = async (params: any) => {
  const url = `${API_ENDPOINTS.SETTING.GET_LANGUAGE_LIST}`;
  let response = await axiosInstance.get(url, { params });
  const rowData = await response?.data;

  const formatedData = Array.isArray(rowData?.data?.data)
    ? rowData?.data?.data.map((item: any) => ({
        languagename: item.LanguageName || "-",
        languagecode: item.LanguageCode || "-",
        LanguageId: item.LanguageId || "-",
        CreatedAt: item.CreatedAt || "-",
      }))
    : [];
  return { formatedData, rowData };
};

export const addLanguage = async (Req: any) => {
  const url = `${API_ENDPOINTS.SETTING.POST_ADD_LANGUAGE}`;
  let response = await axiosInstance.post(url, Req);
};
export const updateLanguage = async (ReqBody: any, id: number | null) => {
  const url = `${API_ENDPOINTS.SETTING.PUT_Update_LANGUAGE}/${id}`;
  const response = await axiosInstance.put(url, ReqBody);
};

// // ADD_BRANCH
// export const addBranch = async (body: any) => {
//   const url = `${API_ENDPOINTS.SETTING.ADD_BRANCH}`;
//   let response = await axiosInstance.post(url, body);
//   console.log("🚀 ~ SettingRepo.ts:34 ~ addBranch ~ response:", response);
// };

// export const updateBranch = async (id?: string | number, body?: any) => {
//   return axiosInstance.post(
//     `${API_ENDPOINTS.SETTING.UPDATE_BRANCH}/${id}`,
//     body
//   );
// };

export const getOrgStructureTree = async (params:Record<string,any>) => {
  const url = `${API_ENDPOINTS.SETTING.GET_ORG_STRUCTURE_TREE}`;
  let response = await axiosInstance.get(`${API_ENDPOINTS.SETTING.GET_ORG_STRUCTURE_TREE}`,{params});
  return response.data
};

export const UpdateCAVOrgStructureTree = async (id:Record<string,any>) => {
  const url = `${API_ENDPOINTS.SETTING.GET_ORG_STRUCTURE_TREE}`;
  let response = await axiosInstance.get(`${API_ENDPOINTS.SETTING.UPDATE_CAV_ORG_STRUCTURE_TREE}/${id}`);
  return response.data
};